import { Directive, Input, OnInit, ViewContainerRef } from '@angular/core';
import { ISectionComponentOutput, ISectionComponentProp } from '../models/group-edit-config';

@Directive({
  selector: '[appDynamic]'
})
export class DynamicDirective implements OnInit {  
    @Input('component') component: any;
    @Input('props') props: ISectionComponentProp[] = [];
    @Input('outputs') outputs: ISectionComponentOutput[] = [];

    constructor(public viewContainerRef: ViewContainerRef) { }  

    ngOnInit(): void {
        this.viewContainerRef.clear();
        const compRef = this.viewContainerRef.createComponent(this.component);
        if(this.props){
            if(this.props.length > 0){
                this.props.forEach(p => {
                    compRef.setInput(p.propName, p.data);
                });
            }
        }
        if(this.outputs){
            if(this.outputs.length > 0){
                this.outputs.forEach(o => {
                    compRef.instance[o.outputName].subscribe(o.handler);
                });
            }
        }
        
        
    }
}
